import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useAppServices } from "../../../hook/services";
import Swal from "sweetalert2";
import DataTable from "./components/DataTable";
import AddDeviceModal from "./components/Modals/AddDevice";
import LoadingScreen from "../../../components/LoadingScreen";

const Devices = () => {
  const AppService = useAppServices();
  const [processing, setProcessing] = useState(true);
  const [devices, setDevices] = useState([]);
  const { locationId } = useParams();
  const getData = async () => {
    const { response } = await AppService.device.get({
      query: `locationId=${locationId}`,
    });
    if (response) {
      setDevices(response.data);
    }
    setProcessing(false);
  };
  useEffect(() => {
    getData();
  }, []);
  const columns = [
    {
      label: "Device Model",
      accessor: "device_model",
      sortable: true,
      renderCell: (row) => (
        <div className="d-flex align-items-center">
          <div className="bg-primary bg-opacity-10 rounded-circle p-2 me-3">
            <i className="bi bi-phone text-primary"></i>
          </div>
          <div className="fw-semibold text-dark">
            {row.device_model || (
              <span className="text-muted">Not specified</span>
            )}
          </div>
        </div>
      ),
    },
    {
      label: "Android Version",
      accessor: "android_version",
      sortable: true,
      renderCell: (row) => (
        <span className="badge bg-light text-dark border px-3 py-2 rounded-pill">
          {row.android_version || "-"}
        </span>
      ),
    },
    {
      label: "App Version",
      accessor: "app_version",
      sortable: true,
      renderCell: (row) => (
        <span className="badge bg-success bg-opacity-10 text-success border border-success border-opacity-25 px-3 py-2 rounded-pill">
          {row.app_version || "-"}
        </span>
      ),
    },
    {
      label: "Android ID",
      accessor: "android_id",
      sortable: true,
      renderCell: (row) => (
        <code className="bg-light px-2 py-1 rounded text-primary small">
          {row.android_id}
        </code>
      ),
    },
    {
      label: "Actions",
      accessor: "actions",
      sortable: false,
      renderCell: (row) => (
        <div className="d-flex gap-2 justify-content-center">
          <button
            className="btn btn-outline-danger btn-sm rounded-circle d-flex align-items-center justify-content-center"
            style={{ width: "36px", height: "36px" }}
            title="Delete Device"
            onClick={() => handleDeviceDelete(row._id)}
          >
            <i className="bi bi-trash"></i>
          </button>
        </div>
      ),
    },
  ];

  const handleDeviceDelete = async (deviceId) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "This device and all its associated sims will be deleted!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    });

    if (result.isConfirmed) {
      try {
        const { response } = await AppService.device.delete({
          query: `_id=${deviceId}`,
        });

        if (response) {
          await Swal.fire("Deleted!", "Device has been deleted.", "success");
          getData();
        }
      } catch (error) {
        Swal.fire("Error!", "Something went wrong.", "error");
      }
    }
  };

  if (processing) {
    return <LoadingScreen loadingText={"Loading devices..."} />;
  }

  return (
    <div className="min-vh-100" style={{ backgroundColor: "#F5F6FA" }}>
      <div className="container-fluid p-4">
        {/* Header Card */}
        <div
          className="card border-0 shadow-sm mb-4"
          style={{ backgroundColor: "white" }}
        >
          <div className="card-body py-4">
            <div className="d-flex justify-content-between align-items-center">
              <div>
                <h4 className="mb-1 fw-bold text-dark">Devices</h4>
                <p className="text-muted mb-0 small">
                  Manage your registered devices
                </p>
              </div>
              <AddDeviceModal />
            </div>
          </div>
        </div>

        <DataTable columns={columns} data={devices} entriesPerPage={10} />
      </div>
    </div>
  );
};

export default Devices;
